<template>
  <span>
    <template v-if="showText">
      <v-icon :color="getIcon.color">{{getIcon.icon}}</v-icon> {{getIcon.text}}
    </template>
    <template v-else>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab x-small outlined :color="getIcon.color" v-bind="attrs" v-on="on"><v-icon>{{getIcon.icon}}</v-icon></v-btn>
      </template>
      <span>{{getIcon.text}}</span>
    </v-tooltip>
    </template>
  </span>
</template>

<script>
  import { mdiAlert,mdiClose,mdiCheck } from '@mdi/js';
  export default {
    props: ['showText','status'],
    data() {
      return {
        iconKey: {
          not_checked: {icon:mdiAlert,color:'warning',text:'Address not checked'},
          check_failed: {icon:mdiAlert,color:'error',text:'Address check failed'},
          address_mismatch: {icon:mdiClose,color:'error',text:'Address check negative'},
          address_matched: {icon:mdiCheck,color:'secondary',text:'Address check positive'},
        }
      }
    },
    computed: {
      getIcon() {
        return (this.status!==undefined&&this.status!==null&&this.status!=='')?this.iconKey[this.status.toLowerCase()]:this.iconKey.not_checked; 
      }
    },
  }
</script>

<style>

</style>
